import React from 'react';
import { TextField, TextFieldProps } from '@mui/material';
import { Field, FormikProps } from 'formik';
import { useIntl } from 'react-intl';

function FormField<U>(props: IFormFieldProps<U>) {
  const { formProps, textFieldProps } = props;
  const intl = useIntl();
  const key = textFieldProps.name as unknown as keyof U;

  return (
    <Field
      {...textFieldProps}
      label={intl.formatMessage({ id: `form-field-${textFieldProps.name}` })}
      value={formProps.values[key]}
      component={TextField}
      onChange={(e: React.ChangeEvent, newValue: any) => {
        const result = formProps.handleChange(key);
        if (result) {
          result(e);
        }
        textFieldProps.onChange?.(newValue);
      }}
      helperText={formProps.touched[key] && formProps.errors[key] ? formProps.errors[key] : null}
      error={!!(formProps.touched[key] && formProps.errors[key])}
    />
  );
}

export interface IFormFieldProps<U> {
  formProps: FormikProps<U>;
  textFieldProps: TextFieldProps;
}

export { FormField };
